var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert alert-danger"},[_c('i',{staticClass:"fas fa-exclamation-triangle"}),_vm._v("  \n   "),_c('strong',[_vm._v("404 not found")]),_vm._v(" \""),_c('em',[_vm._v("#"+_vm._s(_vm.path))]),_vm._v("\"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }